import { render, staticRenderFns } from "./AdminPostGroups.vue?vue&type=template&id=072ac181"
import script from "./AdminPostGroups.vue?vue&type=script&lang=js"
export * from "./AdminPostGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports